import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/hvac';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-off px-4 py-5 sm:py-7" data-id="element-41" data-mp="1hdbdhlshjf57">
      <div className="mx-auto max-w-3xl" data-id="element-42" data-mp="1hdum2bw8wr6k">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-3xl" data-id="element-43" data-mp="1ceqflt0ph7jx">
          Frequently Asked Questions
        </h2>

        <ul className="mt-3 divide-y divide-navy/10 overflow-hidden rounded-lg border border-navy/10 bg-white" data-id="element-44" data-mp="2a179spe5751g">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} data-id="element-45" data-mp="202rk8qurk3u2" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left" data-id="element-46" data-mp="205vti2n35prl">
                  <span className="text-sm font-bold text-navy sm:text-base" data-id="element-47" data-mp="jo9hu1inx3qg">{faq.q}</span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-hvac transition-transform duration-150 ease-soft ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-48" data-mp="1ko9pq3p2ym1o" />
                </button>
                {isOpen && <p className="px-3 pb-2.5 text-sm font-medium leading-snug text-charcoal/80" data-id="element-49" data-mp="1fqq94x4wtx6k">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}